import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Fixes URLs where query strings got URL-encoded into the path
 * e.g., /payment-success%3Fsession_id=abc -> /payment-success?session_id=abc
 */
export function UrlNormalizer() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Check if pathname contains encoded query string (%3F = ?)
    if (pathname.includes("%3F") || pathname.includes("%3f")) {
      const decoded = decodeURIComponent(pathname);
      const questionIndex = decoded.indexOf("?");

      if (questionIndex !== -1) {
        const newPath = decoded.slice(0, questionIndex);
        const newSearch = decoded.slice(questionIndex) + search;

        console.log("[UrlNormalizer] Fixing encoded URL:", pathname, "->", newPath + newSearch);
        navigate(newPath + newSearch + hash, { replace: true });
      }
    }
  }, [location, navigate]);

  return null;
}
